// extracted by mini-css-extract-plugin
export default {"sectionFooter":"SectionFooter_sectionFooter__JOdIx"};